<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div class="section-title">{{ $t("addons") }}</div>

      <div class="d-flex align-items-center">
        <router-link
          v-if="$can('create', 'Add-ons')"
          class="btn-blue"
          to="add-add-ons"
          >{{ $t("add") }}</router-link
        >

        <div class="mx-2" v-if="selectedCinema.length != 0">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onSelect($event, cinema)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row" style="height: 50px">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
              >Select Cinema</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-on:search="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  href="#"
                  name="selectcine"
                  id="selectcine"
                  @click="onSelect($event, cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message">
              <!-- <span>{{ msgcinema }}</span> -->
            </p>
          </div>
        </div>
      </div>

      <table class="list-view-table" style="margin-bottom: 10px">
        <thead>
          <tr>
            <th class="text-right" style="width: 50px">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>

            <th>{{ $t("addonItemName") }}</th>
          </tr>
        </thead>
        <tbody v-if="addonsList.length > 0">
          <tr
            v-for="(item, key) in addonsList"
            :key="key"
            class="light_grey_back"
          >
            <!-- <td>
              <div class="d-flex align-items-center">
                <StatusDot
                  :status="
                    item.add_on_is_active === 'Y'
                      ? 'active'
                      : item.add_on_is_active === 'N' && 'inactive'
                  "
                />

                <b-dropdown right variant="edit" class="ml-2">
                  <b-dropdown-item
                    v-if="$can('update', 'Add-ons')"
                    @click="goToRoute('/master/edit-add-ons', item)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="goToRoute('/master/view-add-ons', item)"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center">
                <StatusDot
                  :status="
                    item.add_on_is_active === 'Y'
                      ? 'active'
                      : item.add_on_is_active === 'N' && 'inactive'
                  "
                />
                <a
                  v-if="$can('update', 'Add-ons')"
                  @click="goToRoute('/master/edit-add-ons', item)"
                  class="edit-pen icon blue-icon cursor-pointer ml-2"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                ></a>
                <a
                  @click="goToRoute('/master/view-add-ons', item)"
                  class="icon-eye blue-icon cursor-pointer ml-2"
                  v-b-tooltip="'View'"
                  tabindex="0"
                ></a>
              </div>
            </td>

            <td>{{ item.add_on_item_name }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import ExhibitorService from "@/services/ExhibitorService";
import CinemaService from "@/services/CinemasService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      selectedid: "",
      searchCinema: "",
      selectedCinema: "",
      addonsList: [],
      isRoleID: true,
      Cinemas: [],
      CinemasCopy: [],
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    let obj = this.secureStore.get("USINFO").cinema_id;

    if (true) {
      this.isRoleID = false;
      this.getCinemasList(obj);
    } else {
      this.getCinemasList(obj);
    }
    this.getviewingnumber();

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema = CinemaObj.cine_name;
      this.cinemaid = CinemaObj.cine_id;
      this.getAddonsList(CinemaObj.cine_id);
    }
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSelect(event, cinema) {
      this.selectedCinema = cinema.cine_name;
      this.cinemaid = cinema.cine_id;
      this.getAddonsList(cinema.cine_id);
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getConcessionList;
      } else {
        this.currentPage = event;
        this.getAddonsList();
      }
    },

    getCinemasList: function (cine_id) {
      // this.Cinemas = [];
      // let body = this.getRequestBody("GET", undefined, this.CinemasMethods);
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
                this.getAddonsList(cine_id);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getAddonsList(cine_id) {
      this.addonsList = [];
      let payload = {
        tableName: "ms_add_ons",
        limit: this.perPage,
        currentPage: this.currentPage,
        cinema_id: cine_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.addonsList = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    goToRoute: function (path, item) {
      const { add_on_id } = item;
      this.$router.push({
        path: path,
        query: {
          add_on_id: add_on_id,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/AddonsComponents/addons.vue